/* eslint-disable no-empty */
import React, { useState, useEffect } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import {
  Box,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  // ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import "./index.scss";
import UploadBatchHeader from "../../../components/UploadBatch/index";
import List from "@mui/material/List";
import CheckboxTitle from "../../../components/UploadBatchRecord/CheckboxTitle/CheckboxTitle";
import SelectedFileList from "../../../components/UploadBatchRecord/SelectedFileList/SelectedFileList";
// import constants from "../../../constants/constantValues";
import { useDispatch, useSelector } from "react-redux";
import {
  handleClearPDFDeleteData,
  clearApiStatus,
  listBoxFiles,
  uploadClientData,
  clearPDFUploadData,
} from "../../../redux/administrator/actions";
import { useLocation, useNavigate } from "react-router-dom";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import Checkbox from "@mui/material/Checkbox";
import AdminFooter from "../../../components/AdminFooter";
import Label from "../../../components/Label/Label";
import ProgressBar from "../../../components/ProgressBar";
import CloseIcon from "@mui/icons-material/Close";
import { adminRoutes } from "../../../routes/routeConstants";

const Index = (props) => {
  const languageData = [
    { name: "English", value: "en" },
    { name: "German", value: "german" },
    { name: "French", value: "french" },
    // { name: "Japanese", value: "japan" },
    // { name: "Chinese", value: "ch" },
    // { name: "Spanish", value: "es" },
    // { name: "Portuguese", value: "pt" },
    // { name: "Romanian", value: "ro" },
    // { name: "Swedish", value: "sv" },
  ];
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();

  const data = useSelector((state) => state?.admin?.batchTypes);
  // const { PREVIOUS
    // , SAVE, GRANT 
  // } = constants;
  const [selectedName, setSelectedButton] = useState("pdfs");
  // const [selectedBottomButton, setBottomButtonName] = useState(PREVIOUS);
  const [checkedFiles, setCheckedFiles] = useState([]);
  const [language, setLanguage] = useState("");
  const [groupData, setGroupData] = useState([]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // let propsData = props?.location?.state;
  let propsData = state;
  if (propsData?.value) {
    localStorage.setItem("pvalue", propsData.value);
    localStorage.setItem("folderName", propsData.folderName);
  }

  let group = useSelector((state) => state?.admin?.boxFiles);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const res = useSelector((state) => state?.admin?.uploadData);

  useEffect(() => {
    // if (selectedName === "pdfs") {
    //   const newDataArray = group?.map((item) => ({
    //     ...item,
    //     language: "en",
    //   }));
    //   setGroupData(newDataArray);
    // } else {
    setIsOpen(false);
    setGroupData(group);
    // }
  }, [group]);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true) {
        setMessage(apiStatus?.message);
        setErr(true);
        dispatch(handleClearPDFDeleteData());
        dispatch(clearApiStatus());
      } else if (apiStatus?.apiSuccess === true) {
        dispatch(handleClearPDFDeleteData());
        dispatch(clearApiStatus());
      }
    }
  }, [apiStatus, dispatch]);

  useEffect(() => {
    let data = {
      folderId: localStorage.getItem("pvalue"),
      fileType: selectedName,
    };
    dispatch(clearPDFUploadData());
    dispatch(listBoxFiles(data));
  }, [selectedName]);

  useEffect(() => {
    let pdata = localStorage.getItem("pvalue");
    let data = {
      folderId: pdata,
      fileType: selectedName,
    };
    dispatch(clearPDFUploadData());
    dispatch(listBoxFiles(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleToggle = (value) => () => {
    // const currentIndex = checkedFiles.indexOf(value);
    const currentIndex = checkedFiles.findIndex((item) => item.id === value.id);

    let newChecked = [...checkedFiles];
    // const valueId = value.id;
    //  const currentIndex = newChecked.findIndex(item => item.id === valueId);
    // const currentIndex = newChecked.indexOf(value);
    // if (!selectAllChecked) {
    //   // If "Select All" is checked, clear the current selection
    //   newChecked = [];
    // }
    // if not then push
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      //  if present then remove
      newChecked.splice(currentIndex, 1);
    }
    setCheckedFiles(newChecked);
    if (selectAllChecked) {
      setSelectAllChecked(!selectAllChecked);
    }
  };

  const removeSelectedFile = (index) => {
    let addedFiles = [...checkedFiles];
    if (index > -1) {
      addedFiles.splice(index, 1);
      setCheckedFiles(addedFiles);
    }
  };
  useEffect(() => {
    if (res?.message === "Task created" && res.apiSuccess === true) {
      setIsOpen(true);
      setMessage("Task created");
      setSeverity("success");
      // isOpen = true;
      // text = "Uploaded";
      // severity = "success"
    }
  }, [res]);

  const onSelectBottomButton = (e, action) => {
    //redirection based on folder selected by user
    // setBottomButtonName(action);
    if (action === "previous") {
      navigate(`/${adminRoutes.listDirectory}`)
    } else if (action === "continue") {
      let newDataArray = [...checkedFiles];
      if (selectedName === "pdfs") {
        newDataArray = newDataArray?.map((item) => ({
          ...item,
          language: language,
        }));

        setCheckedFiles(newDataArray);
      }
      // setGroupData(newDataArray);

      let data = {
        body: {
          folder_name: localStorage.getItem("folderName"),
          client_file_details: newDataArray,
          file_type: selectedName,
        },
      };

      if (checkedFiles?.length > 0) {
        // isOpen = true;
        // text = "Uploaded";
        // severity = "success";
        dispatch(uploadClientData(data));
        dispatch(handleClearPDFDeleteData());
        setTimeout(() => {
          navigate(`/${adminRoutes.reviewBatchRecordDetails}`)
        }, 3000);
      }
    }
  };

  const onSelectHeaderButton = (buttonSelected = "") => {
    setSelectedButton(buttonSelected);

    // let data = {
    //   folderId: localStorage.getItem("pvalue"),
    //   fileType: buttonSelected,
    // };
    // dispatch(listBoxFiles(data));
    setCheckedFiles([]);
    setGroupData([]);
  };
  const handleLanguage = (name, id) => {
    setLanguage(name);

    const updatedLanguageData = groupData?.map((language) => {
      if (id === language.id) {
        return { ...language, language: name };
      }
      return language;
    });
    setGroupData(updatedLanguageData);
  };
  const handleCheckboxChange = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
  };

  const handleSelectAll = () => {
    //const currentIndex = groupData.indexOf(value);

    const newDataArray = group?.map((item) => ({
      ...item,
    }));
    // setGroupData(newDataArray);

    if (!selectAllChecked) {
      // If "Select All" is checked, set all checkboxes as checked
      //  setCheckedFiles(groupData.map((item) => item.value));
      setCheckedFiles(newDataArray);
    } else {
      // If "Select All" is unchecked, clear all checkboxes
      setCheckedFiles([]);
    }
    // Toggle the state of "Select All" checkbox
    setSelectAllChecked(!selectAllChecked);
  };

  const isDisabled = (selectedName, language, checkedFiles) => {
    if (
      selectedName === "pdfs" &&
      (language === "" || checkedFiles.length <= 0)
    ) {
      return true;
    } else if (selectedName !== "pdfs" && checkedFiles.length <= 0) {
      return true;
    } else return false;
  };

  const handleBack = () => {
    navigate(`/${adminRoutes.listDirectory}`)  
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredData = groupData?.filter((item) =>
    item?.name?.toLowerCase().includes(searchTerm)
  );

  return (
    <>
      <Header page="new-project" />
      {isOpen ? (
        <CustomizedSnackbars
          className="popup"
          handleClose={() => {
            setIsOpen(false);
          }}
          severity={severity}
          state={isOpen}
          text={message}
        />
      ) : (
        <></>
      )}
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar selectedKey={"three"} page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            {/* <Box className="uploadBatchHeader-wrap"></Box> */}
            <UploadBatchHeader
              onClick={(e) => {
                onSelectHeaderButton(e);
              }}
              data={data?.upload_in_progress}
              selectedKey={selectedName}
              position="left"
              headerColor="#F5F5F5"
              isDisableOtherBtn={checkedFiles.length > 0}
              handleBack={handleBack}
            />

            {apiStatus?.loader ? (
              <div
                style={{ height: "calc(100vh - 100px)", alignItems: "center" }}
              >
                {" "}
                <ProgressBar />
              </div>
            ) : groupData?.length ? (
              <Grid container>
                <Grid
                  // className="scroll-wrapper"
                  item
                  xs={8}
                  style={{
                    height: "calc(100vh - 144px)",
                    overflowY: "scroll",
                  }}
                >
                  <div
                    style={{
                      position: "sticky",
                      top: "0",
                      zIndex: "1",
                      background: "#fff",
                    }}
                  >
                    {selectedName === "pdfs" && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 24px",
                            // backgroundColor: "#f9f9f9",
                            // borderRadius: "12px",
                            // boxShadow: 1,
                            // flexWrap: "wrap",
                            // gap: 2,
                          }}
                        >
                          {/* Select All Checkbox */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Label
                              fontSize="14px"
                              fontWeight="500"
                              text={`Select All: `}
                            ></Label>

                            {/* <FormControlLabel
                              control={ */}
                            <Checkbox
                              // checked={selectAllChecked}
                              checked={checkedFiles.length === groupData.length}
                              onChange={handleSelectAll}
                              color="primary"
                            />
                            {/* }
                            //   label="Select All"
                            // /> */}
                          </Box>

                          {/* Checked Count */}
                          <Box sx={{ display: "flex", flexDirection: "row" }}>
                            <Label
                              fontSize="14px"
                              fontWeight="500"
                              text={`Selected Files: `}
                            ></Label>

                            <Label
                              fontSize="14px"
                              fontWeight="600"
                              color="#1976d2"
                              text={`${checkedFiles.length}`}
                              paddingLeft="5px"
                            ></Label>
                          </Box>

                          {/* Folder Name */}
                          <Box sx={{ display: "flex", flexDirection: "row" }}>
                            <Label
                              fontSize="14px"
                              fontWeight="500"
                              // color="#1976d2"
                              text={`Drug Type:`}
                            ></Label>
                            <Label
                              fontSize="14px"
                              fontWeight="600"
                              color="#1976d2"
                              text={` ${localStorage.folderName}`}
                              paddingLeft="5px"
                            ></Label>
                          </Box>

                          <Box sx={{ maxWidth: 200 }}>
                            <TextField
                              size="small"
                              // fullWidth
                              label="Search"
                              variant="outlined"
                              value={searchTerm}
                              onChange={handleSearchChange}
                              InputProps={{
                                endAdornment: searchTerm && (
                                  <IconButton
                                    size="small"
                                    onClick={() => setSearchTerm("")}
                                    edge="end"
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                ),
                              }}
                            />
                          </Box>

                          {/* Language Select Dropdown */}
                          <FormControl
                            size="small"
                            sx={{
                              width: 180,
                              flexShrink: 0,
                            }}
                          >
                            <InputLabel id="demo-simple-select-helper-label">
                              Select Language
                            </InputLabel>

                            <Select
                              size="small"
                              labelId="language-select-label"
                              id="language-select"
                              // defaultValue="sl"
                              label="Select Language"
                              onChange={(event) =>
                                handleLanguage(event.target.value)
                              }
                              value={language}
                              className="lang-select"
                            >
                              {/* <MenuItem value="">
                            Select Language
                          </MenuItem> */}
                              {languageData.map((language, index) => (
                                <MenuItem
                                  size="small"
                                  // sx={{
                                  //   display: "flex",
                                  //   justifyContent: "center",
                                  //   alignItems: "center",
                                  // }}
                                  key={index}
                                  value={language.value}
                                >
                                  {language.name}

                                  {/* <ListItemText
                                    primary={language.name}
                                  /> */}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>

                        <Divider style={{ paddingTop: "10px" }} />
                      </>
                    )}
                  </div>

                  {/* <List className="scroller check-box-style"> */}
                  <List className="check-box-style">
                    {filteredData?.map((value, index) => {
                      return (
                        <CheckboxTitle
                          key={index}
                          checked={checkedFiles}
                          onClick={(e) => handleToggle(e)}
                          value={value}
                          selectedName={selectedName}
                          isCheckboxChecked={isCheckboxChecked}
                          language={(name, id) => handleLanguage(name, id)}
                          handleCheckboxChange={handleCheckboxChange}
                          selectAllChecked={selectAllChecked}
                        ></CheckboxTitle>
                      );
                    })}
                  </List>
                </Grid>

                <Grid
                  //  className="scroller scroll-wrapper"
                  item
                  xs={4}
                  style={{
                    height: "calc(100vh - 144px)",
                    overflowY: "auto",
                  }}
                >
                  <Grid container className="selected-file-margin" spacing={2}>
                    {checkedFiles?.map((value, index) => (
                      <Grid key={index} item xs={11} sx={{}}>
                        <SelectedFileList
                          onClick={() => {
                            removeSelectedFile(index);
                          }}
                          value={value}
                        ></SelectedFileList>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                {/* <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <BottomButtonsList
                  onClick={(e, action) => {
                    onSelectBottomButton(e, action);
                  }}
                  selectedKey={selectedBottomButton}
                  // isNextDisable={language === "" || language === "sl"}
                  isNextDisable={
                    isDisabled(selectedName, language, checkedFiles)
                    // selectedName === "pdfs" &&
                    // language === "" &&
                    // checkedFiles.length <= 0
                  }
                  position="end"
                  headerColor="#FFFFF"
                  isPrevious={true}
                ></BottomButtonsList>
              </Grid> */}

                <AdminFooter
                  onHandleClick={(e, action) => {
                    onSelectBottomButton(e, action);
                  }}
                  isSubmitDisable={isDisabled(
                    selectedName,
                    language,
                    checkedFiles
                  )}
                />
              </Grid>
            ) : (
              !apiStatus?.loader && (
                <div className="no-data">
                  <Label
                    text="No Data Found"
                    fontSize="16"
                    fontWeight="600"
                    padding="20px"
                  />
                </div>
              )
            )}
          </Grid>
        </Grid>
        {err && (
          <CustomizedSnackbars
            severity="error"
            state={err}
            text={message}
            handleClose={() => setErr(false)}
          />
        )}
      </Box>
    </>
  );
};

export default Index;
